import { Component, OnInit } from '@angular/core';
import { EtlService } from './etl.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from 'src/app/shared/common/contants';
import { Radiobutton } from 'src/app/shared/common/Radiobutton';
import { FormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { ElasticsearchComponent } from '../elasticsearch/elasticsearch.component';
import { filter } from 'rxjs/operators';
import { UploadButton } from 'src/app/shared/common/uploadButton';
import * as _moment from 'moment';
import { ResumeLoadButton } from 'src/app/shared/common/resumeLoadButton';
import { environment } from 'src/environments/environment';
import { FileUploadButton } from 'src/app/shared/common/fileUploadbutton';
import { EtlActionCheckBox } from 'src/app/shared/common/etlActionCheckBox';

const moment =  _moment;

export interface ETLProcess {
  name: string;
  value: string;
}

@Component({
    selector: 'app-vault-data-migration-etl',
    templateUrl: './vault-data-migration-etl.component.html',
    styleUrls: ['./vault-data-migration-etl.component.scss'],
    standalone: false
})
export class VaultDataMigrationEtlComponent implements OnInit {

  data:any;
  data1:any;
  gridAPI;
  gridAPIValidation;
  loaderAPI;
  vaultvalidationAPI;
  gridData:any;
  gridDataValidation:any;
  extractionData:any=[];
  transformData:any=[];
  loaderData:any=[];
  vaultValidationData:any=[];
  temploaddataValidation:any=[];
  migrationTrace= true;
  loaderTrace = false;
  transformTrace=false;
  validationreport=false;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  lastPageValidation;
  currentPageValidation;
  nextPageValidation;
  nextPagePlusOneValidation;
  totalPagesValidation;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  defaultColDefvalidation;
  rowSelection;
  rowMultiSelectWithClick;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;
  buttonName;
  getdata: any;
  backgroundColorScreen: any;
  backgroundColorButton: any;
  buttonColor = "";
  tempextractparams:any;
  statevaluechange={"fileName":"","fileData":""}
  imagephoto;
  imagephotoshow: any = false;
  value;
  startmigration;
  eachsetId:any=[];
  eachsetITransform:any=[];
  loadsetId:any=[];
  FormValid: UntypedFormGroup;
  validation_messages;
  eachetlName = 'Extraction';
  MappingFile;
  migrationDataLoadLogObject: any = [];
  mgrstatus: any;
  mgrstartdt : any;
  loadingProcess="Extraction";
  columnDefsExtract;
  columnDefsLoader;
  columnDefsvaultvalidation;
  transformApi:any;
  transformsetid="";
  tempextdata:any;
  temptrnsdata:any;
  temploaddata:any;
  setvalidationdata:any;
  mgrid;
  migrationType="ETL";
  constructor(private service:EtlService, private localStorageSettings: LocalStorageSettingsService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private constants: constants,private msg: ErrorMessages,private validation: validationmethod ) {
    this.validation_messages = this.msg.etlTool;
    this.components = {
      buttonRenderer: EtlActionCheckBox,
      downloadbuttonRenderer: FiledownloadComponent,
      uploadbuttonRenderer: UploadButton,
      resumeLoadRenderer:ResumeLoadButton,
      uploadSourceFile:FileUploadButton
    }
   }

  ngOnInit() {
    this.formvalidations();
    this.loadsetId=[];
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.columnDefs = [{
      headerName: 'Select', filter: false, cellRenderer: 'buttonRenderer',
      headerCheckboxSelection: true,
      field:'selection',
      cellRendererParams: {
        updateCheckbox: this.selectedmigrationid.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 100
    },
      {
        headerName: 'Migration Id',
        headerTooltip: 'Migration Id',
        tooltipValueGetter: (params) => 'Migration Id : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Process',
        headerTooltip: 'Process',
        tooltipValueGetter: (params) => 'Process : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'startdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'enddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Initiated By',
        headerTooltip: 'Initiated By',
        tooltipValueGetter: (params) => 'Initiated By : ' + params.value,
        field: 'username',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Folder/Location',
        headerTooltip: 'Folder/Location',
        tooltipValueGetter: (params) => 'Folder/Location : ' + params.value,
        field: 'folderpath',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Log File', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Source Files', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownloadSourceFile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
    ]

    this.columnDefsExtract = [{
      headerName: 'Select', filter: false, cellRenderer: 'buttonRenderer',
      headerCheckboxSelection: true,
      field:'selection',
      cellRendererParams: {
        updateCheckbox: this.selectedmigrationid.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 100
    },
      {
        headerName: 'Migration Id',
        headerTooltip: 'Migration Id',
        tooltipValueGetter: (params) => 'Migration Id : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Process',
        headerTooltip: 'Process',
        tooltipValueGetter: (params) => 'Process : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'startdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'enddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Initiated By',
        headerTooltip: 'Initiated By',
        tooltipValueGetter: (params) => 'Initiated By : ' + params.value,
        field: 'username',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Folder/Location',
        headerTooltip: 'Folder/Location',
        tooltipValueGetter: (params) => 'Folder/Location : ' + params.value,
        field: 'folderpath',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Log File', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.downloadmappingfileExtract.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Source Files', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownloadSourceFile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
    ]

    this.columnDefsLoader = [{
      headerName: 'Select', filter: false, cellRenderer: 'buttonRenderer',
      headerCheckboxSelection: true,
      field:'selection',
      cellRendererParams: {
        updateCheckbox: this.selectedmigrationid.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 100
    },
      {
        headerName: 'Migration Id',
        headerTooltip: 'Migration Id',
        tooltipValueGetter: (params) => 'Migration Id : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Process',
        headerTooltip: 'Process',
        tooltipValueGetter: (params) => 'Process : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'startdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'enddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Initiated By',
        headerTooltip: 'Initiated By',
        tooltipValueGetter: (params) => 'Initiated By : ' + params.value,
        field: 'username',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Folder/Location',
        headerTooltip: 'Folder/Location',
        tooltipValueGetter: (params) => 'Folder/Location : ' + params.value,
        field: 'folderpath',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Validation Report', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.downloadmappingfileLOader.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Source Files', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownloadSourceFile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
    ]


    this.columnDefsvaultvalidation = [
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Run Instance',
        headerTooltip: 'Run Instance',
        tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: (params) => 'Object Name : ' + params.value,
        field: 'objectname',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'loadstatus',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'loadstartdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'loadenddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Loader Order',
        headerTooltip: 'Loader Order',
        tooltipValueGetter: (params) => 'Loader Order : ' + params.value,
        field: 'loadorder',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Success Count',
        headerTooltip: 'Success Count',
        tooltipValueGetter: (params) => 'Success Count : ' + params.value,
        field: 'successcount',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Fail Count',
        headerTooltip: 'Fail Count',
        tooltipValueGetter: (params) => 'Fail Count : ' + params.value,
        field: 'failcount',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Exception',
        headerTooltip: 'Exception',
        tooltipValueGetter: (params) => 'Exception : ' + params.value,
        field: 'exception',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Success Log', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownloadSuccess.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },

      {
        headerName: 'Failure Log', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownloadFailure.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      // {
      //   headerName: 'Download Uploaded File', filter: false, cellRenderer: 'downloadbuttonRenderer',
      //   cellRendererParams: {
      //     docdownload: this.downloaduploadedfile(),
      //     //delete: this.deleteIcon.bind(this),
      //   }, width: 120
      // },
      {
        headerName: 'Upload Source file', filter: false, cellRenderer: 'uploadSourceFile',
        cellRendererParams: {
          uploadSourceFile: this.uploadloaderfile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Action', filter: false, cellRenderer: 'resumeLoadRenderer',
        cellRendererParams: {
          resumeLoadButton: this.resumeLoadfile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
    ]

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.defaultColDefvalidation={
      sortable: true,
      resizable: true,
      filter: true
    }
    this.rowSelection= 'multiple',
    this.rowMultiSelectWithClick= true,
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.startmigration="";
    this.retriveMappingFile();
    this.retrieveMigrationLog();

  }

  //excel export function
  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }



  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl("")
    });
  }

    //pagination code
    onPaginationChanged() {
      if (this.gridAPI) {
        this.lastPage = this.gridAPI.paginationIsLastPageFound();
        this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
        this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
        this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
        this.totalPages = this.gridAPI.paginationGetTotalPages()
      }
    }

    //this function is for going to the given page number
    onSearchChange(searchValue: number) {
      this.gridAPI.paginationGoToPage(searchValue - 1);
    }

    // below function is for changing the no of rows per page
    onPageSizeChanged(newPageSize) {
      var value = this.pageSize;
      this.gridAPI.setGridOption('paginationPageSize', Number(value));
    }

    // below function is for going to next page
    onBtNext() {
      console.log("next")
      this.gridAPI.paginationGoToNextPage();
    }

    // below function for going to previous page
    onBtPrevious() {
      console.log("previous")
      this.gridAPI.paginationGoToPreviousPage();
    }

    // below function for going to first page
    onBtFirst() {
      this.gridAPI.paginationGoToFirstPage();
    }

    // below function for going to last page
    onBtLast() {
      this.gridAPI.paginationGoToLastPage();
    }
    //pagination code ends

      //pagination code
      onPaginationChangedvalidation() {
        if (this.gridAPIValidation) {
          this.lastPageValidation = this.gridAPIValidation.paginationIsLastPageFound();
          this.currentPageValidation = this.gridAPIValidation.paginationGetCurrentPage() + 1
          this.nextPageValidation = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
          this.nextPagePlusOneValidation = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
          this.totalPagesValidation = this.gridAPIValidation.paginationGetTotalPages()
        }
      }

      //this function is for going to the given page number
      onSearchChangevalidation(searchValue: number) {
        this.gridAPIValidation.paginationGoToPage(searchValue - 1);
      }

      // below function is for changing the no of rows per page
      onPageSizeChangedvalidation(newPageSize) {
        var value = this.pageSize;
        this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
      }

      // below function is for going to next page
      onBtNextvalidation() {
        console.log("next")
        this.gridAPIValidation.paginationGoToNextPage();
      }

      // below function for going to previous page
      onBtPreviousvalidation() {
        console.log("previous")
        this.gridAPIValidation.paginationGoToPreviousPage();
      }

      // below function for going to first page
      onBtFirstvalidation() {
        this.gridAPIValidation.paginationGoToFirstPage();
      }

      // below function for going to last page
      onBtLastvalidation() {
        this.gridAPIValidation.paginationGoToLastPage();
      }
      //pagination code ends


  etlProcess: ETLProcess[] = [
    { name: 'Extract', value: 'Extraction' },
    { name: 'Transform', value: 'Transform'},
    { name: 'Load', value: 'Loader'},
  ];



  start(){
    if(confirm("This action will start migration process.Are you sure you want to continue?")){
      // added dummy parameter for comment
      let startmigrationData
        this.service.startmigration(startmigrationData).subscribe(res=>{
          console.log(res);
          if(res.error===true){

            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          }else{
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
            this.retrieveMigrationLog();
          }
        })
    }
  }

  abort(){
    if(confirm("This action will abort migration process.Are you sure you want to continue?")){
      this.service.abortmigration(this.localStorageSettings.getSettings("dnsName"), this.migrationType,"Aborted",2).subscribe(res=>{
        console.log(res);
        if(res.error===true){

          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.retrieveMigrationLog();
        }
      })
    }
  }

  complete(){

    if(confirm("This action will complete migration process. Are you sure you want to continue?")){

      this.service.completemigration(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{

        console.log(res);

        if(res.error===true){



          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });

        }else{

          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.retrieveMigrationLog();

        }

      })

    }

  }

  retrieveMigrationLog(){
    this.spinner.start();
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName")).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });

        this.spinner.stop();

      }

      else {

        this.migrationDataLoadLogObject = response;

        console.log(this.migrationDataLoadLogObject);

        this.mgrstatus = "";

        this.mgrstartdt = "";

        this.mgrid = "";



          for(let i=0;i<this.migrationDataLoadLogObject.length;i++){

            if(this.migrationDataLoadLogObject[i].state === "In Progress"){

              this.mgrstatus = this.migrationDataLoadLogObject[i].state;
              if(this.migrationDataLoadLogObject[i].startdt !== null){
              this.mgrstartdt = moment(this.migrationDataLoadLogObject[i].startdt).format("YYYY-MM-DD HH:mm:ss");
              console.log("date")
              }else{
                this.mgrstartdt = "Date not provided";
              }

              this.mgrid = this.migrationDataLoadLogObject[i].migrationId;


              console.log(this.migrationDataLoadLogObject);
              this.spinner.stop();
              return;
            }

            if(this.mgrstatus != "In Progress"){

              this.mgrstatus = "Migration is not in progress";

            }

        }

        this.spinner.stop();

      }

    });
  }


  uploadFile(){
    if (!this.FormValid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.FormValid);

      this.validation.getvalidationmessage();

    }else{

    if(this.MappingFile !==null || this.MappingFile !== "" || this.MappingFile !== undefined){
      if(confirm("Are you sure you want to overwrite the existing file.")){
      this.spinner.start()
    let dnsName = this.localStorageSettings.getSettings("vaultDnsname");
    this.statevaluechange.fileName="DM_Mappingfile.xlsx";
    this.service.uploadMappingFile(this.statevaluechange,dnsName).subscribe(response =>{
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });

      } else {
        this.spinner.stop();
        console.log(response)
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });

      }
      this.FormValid.reset();
      this.spinner.stop();
      this.retriveMappingFile();
      this.cancel();
    });
  }else{
    this.FormValid.reset();
    this.cancel();
  }
}

}
  }

  cancel(){
    this.formvalidations()
    this.FormValid.controls.imageName.clearValidators();
    this.statevaluechange={fileName:"",fileData:""};
  }



    onGridReadyRefresh(extract){
      this.retrieveMigrationLog()
      this.migrationTrace=true;
    this.loaderTrace=false;
    this.transformTrace=false;
    this.gridData=[];
    this.tempextractparams = extract
    this.gridAPI = extract.api;
    this.gridColumnAPI = extract.columnApi;
    this.gridAPI.setGridOption('rowData', [])
    this.spinner.start();
    if (
      this.localStorageSettings.getSettings("dnsName") &&
      this.mgrid!== null &&
      this.migrationType !== null &&
      typeof this.mgrid !== "undefined" &&
      typeof this.migrationType !== "undefined"
    ){
    this.service.retrieveMigrationExtracttrace(this.localStorageSettings.getSettings("dnsName"),this.mgrid,this.migrationType ).subscribe((val) => {
      console.log(val)
      this.gridData = val;
      if(this.gridData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.tempextdata=[];
        this.extractionData=[];
       for(let i=0;i<this.gridData.length;i++){
         if(this.gridData[i].activity ==="Extraction"){
          if(this.gridData[i].migrationid == this.mgrid){

            console.log(this.mgrid + "2");

           this.gridData[i].setName = "SET"+this.gridData[i].setid;

           this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid

           this.tempextdata = this.gridData[i];

           this.extractionData.push(this.tempextdata);

          }
         }
       }
       console.log(this.extractionData)
        this.gridAPI.setGridOption('rowData', this.extractionData)
        this.spinner.stop();
      }
    });
    }
  }
    onGridReadyLoaderRefresh(loader){
      this.loaderTrace=true;
      this.migrationTrace=false;
      this.transformTrace=false;
      this.gridData=[];
      this.loaderAPI = loader;
      this.gridAPI = loader.api;
      this.gridAPI.setGridOption('rowData', [])
      this.spinner.start();
      this.service.retrieveLoaderExtractTrace(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
        console.log(val)
        this.gridData = val;
        if(this.gridData.length ===0){
          this.gridAPI.setGridOption('rowData', [])
          this.spinner.stop();
        }else{
          this.temploaddata=[];
          this.loaderData=[];
         for(let i=0;i<this.gridData.length;i++){
          if(this.gridData[i].activity ==="Load"){
           this.gridData[i].setName = "SET"+this.gridData[i].setid;
           this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid
           this.temploaddata = this.gridData[i];
           this.loaderData.push(this.temploaddata);
          }

         }
         console.log(this.loaderData)
         this.gridAPI.setGridOption('rowData', this.loaderData)
         this.onGridReadyVaultValidation(this.vaultvalidationAPI);
         this.spinner.stop();
        }
      });
    }




    onGridReadyTransformRefresh(transform){
      console.log(transform)
      this.transformTrace=true;
    this.migrationTrace=false;
    this.loaderTrace=false;
    this.gridData=[];
    this.transformApi = transform;
    this.gridAPI = transform.api;
    this.gridAPI.setGridOption('rowData', [])
    this.spinner.start();
    this.service.retrieveMigrationTransformtrace(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val)
      this.gridData = val;
      if(this.gridData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temptrnsdata=[];
        this.transformData=[];
       for(let i=0;i<this.gridData.length;i++){
         if(this.gridData[i].activity ==="Transform"){
         this.gridData[i].setName = "SET"+this.gridData[i].setid;
         this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid
         this.temptrnsdata = this.gridData[i];
         this.transformData.push(this.temptrnsdata);
         }
       }
       console.log(this.transformData)
       this.gridAPI.setGridOption('rowData', this.transformData)
       this.spinner.stop();
      }
    });
    }

  // below function is to load the ag grid
  onGridReady(params) {
    this.retrieveMigrationLog()
    this.migrationTrace=true;
    this.loaderTrace=false;
    this.transformTrace=false;
    this.gridData=[];
    this.tempextractparams = params
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridAPI.setGridOption('rowData', [])
    this.eachsetId=[];
    this.spinner.start();
    if (
      this.localStorageSettings.getSettings("dnsName") &&
      this.mgrid!== null &&
      this.migrationType !== null &&
      typeof this.mgrid !== "undefined" &&
      typeof this.migrationType !== "undefined"
    ){
    this.service.retrieveMigrationExtracttrace(this.localStorageSettings.getSettings("dnsName"),this.mgrid,this.migrationType ).subscribe((val) => {
      console.log(val)
      this.gridData = val;
      if(this.gridData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.tempextdata=[];
        this.extractionData=[];
       for(let i=0;i<this.gridData.length;i++){
         if(this.gridData[i].activity ==="Extraction"){
          if(this.gridData[i].migrationid == this.mgrid){

            console.log(this.mgrid + "2");

           this.gridData[i].setName = "SET"+this.gridData[i].setid;

           this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid

           this.tempextdata = this.gridData[i];

           this.extractionData.push(this.tempextdata);

          }
         }
       }
       console.log(this.extractionData)
        this.gridAPI.setGridOption('rowData', this.extractionData)
        this.spinner.stop();
      }
    });
  }
}

  onGridReadyTransform(params){
    this.transformTrace=true;
    this.migrationTrace=false;
    this.loaderTrace=false;
    this.gridData=[];
    this.transformApi = params;
    this.gridAPI = params.api;
    this.gridAPI.setGridOption('rowData', [])
    this.eachsetITransform=[];
    this.spinner.start();
    this.service.retrieveMigrationTransformtrace(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val)
      this.gridData = val;
      if(this.gridData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temptrnsdata=[];
        this.transformData=[];
       for(let i=0;i<this.gridData.length;i++){
         if(this.gridData[i].activity ==="Transform"){
         this.gridData[i].setName = "SET"+this.gridData[i].setid;
         this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid
         this.temptrnsdata = this.gridData[i];
         this.transformData.push(this.temptrnsdata);
         }
       }
       console.log(this.transformData)
       this.gridAPI.setGridOption('rowData', this.transformData)
       this.spinner.stop();
      }
    });
  }


  onGridReadyLoader(params){
    this.loaderTrace=true;
    this.migrationTrace=false;
    this.transformTrace=false;
    this.gridData=[];
    this.loaderAPI = params;
    this.gridAPI = params.api;
    this.gridAPI.setGridOption('rowData', [])
    this.loadsetId=[];
    this.spinner.start();
    this.service.retrieveLoaderExtractTrace(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val)
      this.gridData = val;
      if(this.gridData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temploaddata=[];
        this.loaderData=[];
       for(let i=0;i<this.gridData.length;i++){
        if(this.gridData[i].activity ==="Load"){
         this.gridData[i].setName = "SET"+this.gridData[i].setid;
         this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid
         this.temploaddata = this.gridData[i];
         this.loaderData.push(this.temploaddata);
        }

       }
       console.log(this.loaderData)
       this.gridAPI.setGridOption('rowData', this.loaderData)
       this.spinner.stop();
      }
    });
  }

  onGridReadyVaultValidation(params){
    this.migrationTrace=false;
    this.transformTrace=false;
    this.loaderTrace=true;
    this.vaultvalidationAPI = params;
    this.gridAPIValidation = params.api;
    this.gridDataValidation=[];
    this.gridAPIValidation.setGridOption('rowData', [])
    this.spinner.start();
    if(this.localStorageSettings.getSettings("dnsName")!=undefined||this.localStorageSettings.getSettings("dnsName")!=null){
    this.service.retrieveVaultInstruction(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val)
      this.gridDataValidation = val;
      if(this.gridDataValidation.length ===0){
        this.gridAPIValidation.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temploaddataValidation=[];
        this.vaultValidationData=[];
       for(let i=0;i<this.gridDataValidation.length;i++){
         this.gridDataValidation[i].setName = "SET"+this.gridDataValidation[i].setid;
         this.gridDataValidation[i].runInstance = "Run_"+this.gridDataValidation[i].migrationid
         this.temploaddataValidation = this.gridDataValidation[i];
         this.vaultValidationData.push(this.temploaddataValidation);

       }
       console.log(this.vaultValidationData)
       this.gridAPIValidation.setGridOption('rowData', [])
       this.spinner.stop();
      }
    });}
  }


  refresh(){
    this.loadsetId=[];
    if(this.loadingProcess===""){
      this.eachsetId=[];
      this.loadingProcess="Extraction"
    }

    if(this.loadingProcess==="Transform"){
      this.eachsetITransform=[];
      this.onGridReadyTransformRefresh(this.transformApi)
    }else if(this.loadingProcess ==="Extraction"){
      this.eachsetId=[];
    this.onGridReadyRefresh(this.tempextractparams)
    }else if(this.loadingProcess ==="Loader"){
      this.loadsetId=[];
      this.onGridReadyLoaderRefresh(this.loaderAPI)
    }
  }

  selectedprocess(e){
    this.loadingProcess="";
    console.log(e)
    this.loadingProcess = e;
    if(this.loadingProcess==="Transform"){
      this.eachsetITransform=[];
      this.onGridReadyTransformRefresh(this.transformApi)
    }else if(this.loadingProcess ==="Extraction"){
      this.eachsetId=[];
    this.onGridReadyRefresh(this.tempextractparams)
    }else if(this.loadingProcess ==="Loader"){
      this.loadsetId=[];
      this.onGridReadyLoaderRefresh(this.loaderAPI)
    }
  }


  selectedmigrationid(migrationdata){
    console.log(migrationdata)
    console.log(this.loadingProcess)
    if(this.loadingProcess==="Transform"){
      // console.log(migrationdata.rowData.setid)
      // if(this.transformsetid===""){
      // this.transformsetid = migrationdata.rowData.setid;
      // }else{
      //   this.transformsetid =this.transformsetid+","+migrationdata.rowData.setid;
      // }
      //console.log(this.transformsetid)
      if(migrationdata.event.checked===true){
        console.log(migrationdata.rowData.setid)
        let setid = migrationdata.rowData.setid;
        console.log(setid)
        this.eachsetITransform.push(setid);
      }else{
        this.eachsetITransform.filter(eachtransform=>{
          console.log(eachtransform)
          if(eachtransform === migrationdata.rowData.setid){
            let transformsetid = this.eachsetITransform.indexOf(eachtransform);
            this.eachsetITransform.splice(transformsetid,1)
          }
        })
      }
      console.log(this.eachsetITransform)

    }
    if(this.loadingProcess==="Extraction"){
      if(migrationdata.event.checked===true){
        console.log(migrationdata.rowData.setid)
        let setid = migrationdata.rowData.setid+"";
        console.log(setid)
        this.eachsetId.push(setid);
      }else{
        this.eachsetId.filter(eachextract=>{
          console.log(eachextract)
          if(eachextract === migrationdata.rowData.setid+""){
            let extractsetid = this.eachsetId.indexOf(eachextract);
            this.eachsetId.splice(extractsetid,1)
          }
        })
      }
      console.log(this.eachsetId)
    }
    else if(this.loadingProcess==="Loader"){
      console.log(migrationdata)
      if(migrationdata.event.checked===true){
        let checkvaultvalidation={
          "setName":migrationdata.rowData.setid,
          "migrationid":migrationdata.rowData.migrationid
        }
        console.log(checkvaultvalidation)
        this.loadsetId.push(checkvaultvalidation);
        if(this.loadsetId.length===0){
          this.validationreport=false;
        }else{
          this.validationreport=true;
        this.bindvaultvalidationreport(this.loadsetId);
      }
      }else{
        this.loadsetId.filter(eachvaultvalidation=>{
          if(eachvaultvalidation.setName===migrationdata.rowData.setid){
          let setid = this.loadsetId.indexOf(eachvaultvalidation)
          this.loadsetId.splice(setid,1)
          console.log(this.loadsetId)
          this.bindvaultvalidationreport(this.loadsetId);
          }
        })
      }
  }

  }

  onGridReadyVaultValidationRefresh(vaultrefresh,selectedload){
    this.migrationTrace=false;
    this.transformTrace=false;
    this.loaderTrace=true;
    this.vaultvalidationAPI = vaultrefresh;
    this.gridAPIValidation = vaultrefresh.api;
    this.gridDataValidation=[];
   // this.gridAPIValidation.setGridOption('rowData', [])
    this.spinner.start();
    if(this.localStorageSettings.getSettings("dnsName")!=undefined||this.localStorageSettings.getSettings("dnsName")!=null){
    this.service.retrieveVaultInstruction(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val)
      this.gridDataValidation = val;
      if(this.gridDataValidation.length ===0){
        //this.gridAPIValidation.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temploaddataValidation=[];
        this.vaultValidationData=[];
       for(let i=0;i<this.gridDataValidation.length;i++){
         this.gridDataValidation[i].setName = "SET"+this.gridDataValidation[i].setid;
         this.gridDataValidation[i].runInstance = "Run_"+this.gridDataValidation[i].migrationid
         this.temploaddataValidation = this.gridDataValidation[i];
         this.vaultValidationData.push(this.temploaddataValidation);

       }
       console.log(this.vaultValidationData)
       console.log(selectedload)
       this.setvalidationdata=[];
       this.gridDataValidation.filter(element => {
        selectedload.forEach(eachset => {
          if(eachset.setName === element.setid && eachset.migrationid === element.migrationid){
            console.log(element)
            console.log(eachset.setid+"  "+ eachset.migrationid)
            let elementdata = element;
            this.setvalidationdata.push(elementdata);
          }
        });
      });
      console.log(this.setvalidationdata)
      this.gridAPIValidation.setGridOption('rowData', this.setvalidationdata)
       this.spinner.stop();
      }
    });}
  }

  bindvaultvalidationreport(eachsetdata){
    console.log(eachsetdata)
    this.setvalidationdata=[];
    this.onGridReadyVaultValidationRefresh(this.vaultvalidationAPI,eachsetdata);
  }

  onTransformation()
  {
    if(this.eachsetId.length===0){
      return this.snackbar.open("Please select Extract to Transform", "OK", { duration: 5000 });
    }else{
      if(confirm("Initiating the Transformation for"+" "+this.eachsetId+". "+"Click OK to Proceed OR Cancel to ignore.")){
      this.data={
        "dnsId":this.localStorageSettings.getSettings("dnsName"),
        "userId":this.localStorageSettings.getSettings("UserId"),
        "dnsName":this.localStorageSettings.getSettings("vaultDnsname"),
        "setId":this.eachsetId
      }
      this.spinner.start();
      console.log(this.data)
      this.service.transformMigration(this.data).subscribe(res=>{
      console.log(res);
      this.spinner.stop();
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
    })
 }
}

}
  onLoading(){
    if(this.eachsetITransform.length===0){
      return this.snackbar.open("Please select Transformation to Load", "OK", { duration: 5000 });
    }
    else{
      if(confirm("Initiating the Migration Load for"+" "+ this.eachsetITransform+"."+ " Click OK to Proceed OR Cancel to ignore.")){
      this.transformsetid="";
      this.data={
        "dnsId":this.localStorageSettings.getSettings("dnsName"),
        "userId":this.localStorageSettings.getSettings("UserId"),
        "dnsName":this.localStorageSettings.getSettings("vaultDnsname")
      }
      this.eachsetITransform.filter(eachtransformsetid=>{
        if(this.transformsetid===""){
          this.transformsetid=eachtransformsetid;
        }else{
          this.transformsetid= this.transformsetid+","+eachtransformsetid
        }
      });
      this.spinner.start();
      this.service.loadToVault(this.data.dnsName,this.data.dnsId,this.transformsetid,this.migrationType).subscribe(res=>{
        console.log(res);
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        this.transformsetid="";
      })
    }
  }

  }

  onExtration(){
    // this.service.retrieve().subscribe(res=>{
    //   console.log(res);
    //   this.service.downloadFile(res, 'jsontocsv');

    // })
  }


  retriveMappingFile(){
    this.MappingFile="";
    this.spinner.start();
    this.service.retriveMappingFile(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
      console.log(res.mappingfile);
      if(res === "" || res === undefined || res === null){
        this.spinner.stop();
        //this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      }else if(res.mappingfile === "object not found"){
        this.spinner.stop();
      }
      else{
        this.spinner.stop();
        this.MappingFile=res.mappingfile;
        //this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      }
    })
  }

  readThisimage(inputValue: any,filecheck:any): void {
    let ischeckfile=false
   var file: File = inputValue.files[0];
   var FileS: File = inputValue.files[0];
   console.log(file.type)
   if(filecheck==='csv'){
     if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
       ischeckfile=true
     }
   }
   if (ischeckfile) {

     console.log(file.size / 1000)
     var size = file.size / 1000
     if (size <= 25072) {
           var fileName = FileS.name;
           //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

           var photo: FileReader = new FileReader();
            photo.onloadend = e => {
             var img = photo.result;
             console.log(photo.result);
             var photobase64result = photo.result.toString().split(",", 2)[1];

             // this is to check the file is empty or not
               this.imagephoto = photo.result.toString();
               this.imagephotoshow = true;
               this.statevaluechange.fileData = photobase64result;
               this.statevaluechange.fileName = fileName;
               this.FormValid.controls.imageName.setValue(fileName);
               console.log(this.statevaluechange)
               // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

           };
               photo.readAsDataURL(file);
     } else {
       this.snackbar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
         duration: 5000,
       });
     }
   } else {
     this.snackbar.open(file.name + "is invalid file. Please select Excel file ", "OK", {
       duration: 5000,
     });
   }
 }

 mappingFiletoS3($event,filecheck): void {
    this.readThisimage($event.target,filecheck);
  }


  downloadmappingfile(){
    // if(this.MappingFile==="" || this.MappingFile === null || this.MappingFile === undefined){
    //   this.snackbar.open("No File to Download","OK", { duration: 5000 });
    // }else{
    //   this.spinner.start();
    //   console.log(this.MappingFile)
    //   this.service.downloadMappingFile(this.localStorageSettings.getSettings("dnsName"),"Migration/Mapping_Document/DM_Mappingfile.xlsx").subscribe(res=>{
    //     console.log(res);
    //     if(res.error===true){
    //       this.spinner.stop();
    //       this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
    //     }else{
    //       this.downloadMappingfileLocal()
    //       this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
    //     }
    //   })
    // }
  }

  MappingFileDoc
  downloadMappingfileLocal(){
      this.spinner.start();
    this.service.download_test(environment.springBase+"/downloadFile/mapping/")
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        link.download = "DM_Mappingfile.xlsx";
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
      this.spinner.stop();

  }


  downloadmappingfileExtract(e){
    console.log(e.rowData.logfilepath)
    if(this.MappingFile==="" || this.MappingFile === null || this.MappingFile === undefined){
      this.snackbar.open("No File to Download","OK", { duration: 5000 });
    }else{
      this.spinner.start();
      this.service.downloadExtractFile(this.localStorageSettings.getSettings("dnsName"),e.rowData.logfilepath).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.downloadExtractFileLocal(e.rowData.logfilepath);
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })
    }
  }

  downloadExtractFileLocal(filepath){
    this.spinner.start();
    this.service.download_test(environment.springBase+"/downloadFile/extract/"+filepath)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        link.download = "Extractionlog.csv";
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
      this.spinner.stop();
  }



  zipDoc
zipdownload(e) {
  console.log(e.rowData.logfilepath)
  this.zipDoc = e.rowData.logfilepath
    this.spinner.start();
  this.service.download_zip(this.zipDoc)
    .subscribe(x => {
      console.log(x)
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x],{type:'application/zip'});

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      console.log(data)
      var link = document.createElement('a');
      link.href = data;
      console.log(e.rowData.fileName)
      link.download = e.rowData.setName+".zip";
      console.log("ento")
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();

}

  Doc
docdownload(e) {
  console.log(e.rowData)
  this.Doc = e.rowData.logfilepath
  if(this.Doc===undefined || this.Doc=== "" || this.Doc ===null){
    this.snackbar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    });
  }else{
    this.spinner.start();
  this.service.download_test(this.Doc)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = e.rowData.fileName;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
}

successDoc
docdownloadSuccess(e){
  console.log(e.rowData)
  this.successDoc = e.rowData.CSVdownloadpath_success
  if(this.successDoc===undefined || this.successDoc=== "" || this.successDoc ===null){
    this.snackbar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    });
  }else{
    this.spinner.start();
  this.service.download_test(this.successDoc)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = e.rowData.objectname+".csv";
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
}

failureDoc
docdownloadFailure(e){
  console.log(e.rowData)
  this.failureDoc = e.rowData.CSVdownloadpath_failure
  if(this.failureDoc===undefined || this.failureDoc=== "" || this.failureDoc ===null){
    this.snackbar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    });
  }else{
    this.spinner.start();
  this.service.download_test(this.failureDoc)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = e.rowData.objectname+".csv";
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
}

downloadmappingfileLOader(e){
  // console.log(e)
  //   if(e.rowData.validationreportpath==="" || e.rowData.validationreportpath === null || e.rowData.validationreportpath === undefined){
  //     this.snackbar.open("No File to Download","OK", { duration: 5000 });
  //   }else{
  //     this.spinner.start();
  //     this.service.downloadMappingFile(this.localStorageSettings.getSettings("dnsName"),e.rowData.validationreportpath).subscribe(res=>{
  //       console.log(res);
  //       if(res.error===true){
  //         this.spinner.stop();
  //         this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
  //       }else{
  //         this.downloadValidationReport(e.rowData.validationreportpath)
  //         this.spinner.stop();
  //         this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
  //       }
  //     })
  //   }
}

Validation_report
downloadValidationReport(path){
    this.spinner.start();
  this.service.download_test(environment.springBase+"/downloadFile/validation/"+path)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = "validationReport.csv";
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();

}




downloaduploadedfile(){

}

uploadloaderfile(inputValue){
  console.log(inputValue.event.target)
    let ischeckfile=false
   var file: File = inputValue.event.target.files[0];
   var FileS: File = inputValue.event.target.files[0];
   console.log(file.type)
     if (file.type === 'application/vnd.ms-excel'){
       ischeckfile=true
     }

   if (ischeckfile) {

     console.log(file.size / 1000)
     var size = file.size / 1000
     if (size <= 25072) {
           var fileName = FileS.name;
           //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

           var photo: FileReader = new FileReader();
            photo.onloadend = e => {
             var img = photo.result;
             console.log(photo.result);
             var photobase64result = photo.result.toString().split(",", 2)[1];

             // this is to check the file is empty or not
               this.imagephoto = photo.result.toString();
               this.imagephotoshow = true;
               let objectNametemp = inputValue.rowData.objectname
               let id = inputValue.rowData.id;
               let path = "sb-beigene/Load_"+inputValue.rowData.migrationid+"/TransformFiles/SET"+inputValue.rowData.setid;
               this.statevaluechange.fileData = photobase64result;
               this.statevaluechange.fileName = fileName;
               console.log(this.statevaluechange)
               this.uploadSourceFileService(this.statevaluechange,path,id,objectNametemp);
               path="";
               id="";
               objectNametemp="";
               this.FormValid.controls.imageName.setValue(fileName);
              // this.cancel()
               // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

           };
               photo.readAsDataURL(file);
     } else {
       this.snackbar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
         duration: 5000,
       });
     }
   } else {
     this.snackbar.open(file.name + "is invalid file. Please select Excel file ", "OK", {
       duration: 5000,
     });
   }
}

uploadSourceFileService(sourcefile,pathtemp,id,objectNametemp){
  this.spinner.start();
      console.log(sourcefile)
      let sourcefiletemp = {
        fileName:sourcefile.fileName,
        fileData:sourcefile.fileData,
        path:"C:/TransformAndLoad/"+pathtemp,
        action:id,
        objectName:objectNametemp
      }
      console.log(sourcefiletemp)
      this.service.uploadingSourceFile(sourcefiletemp,this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.onGridReadyVaultValidationRefresh(this.vaultvalidationAPI,this.loadsetId);
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })
}

resumeLoadfile(e){
  if(confirm("Initiating Resume Load, Are you sure you want to continue?")){
  let setid = e.rowData.setid
  let objectName = e.rowData.objectname;
  this.data={
    "dnsId":this.localStorageSettings.getSettings("dnsName"),
    "userId":this.localStorageSettings.getSettings("UserId"),
    "dnsName":this.localStorageSettings.getSettings("vaultDnsname")
  }
  this.spinner.start();
      this.service.resumeLoadToVault(this.data.dnsName,this.data.dnsId,setid,this.migrationType,objectName).subscribe(res=>{
        console.log(res);
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        setid="";
      })
    }
}



sourceFile
zipdownloadSourceFile(e){
  console.log(e.rowData.sourcefilepath)
  this.sourceFile = e.rowData.sourcefilepath
  if(e.rowData.sourcefilepath==="" || e.rowData.sourcefilepath === null || e.rowData.sourcefilepath === undefined){
    this.snackbar.open("No File to Download","OK", { duration: 5000 });
  }else{
    this.spinner.start();
  this.service.download_zip(this.sourceFile)
    .subscribe(x => {
      console.log(x)
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x],{type:'application/zip'});

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      console.log(data)
      var link = document.createElement('a');
      link.href = data;
      console.log(e.rowData.fileName)
      link.download = "Transformdata"+e.rowData.setName+".zip";
      console.log("ento")
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }

}
downloadSourceFileLocal(e){

}


}
